const ScoreParecerInteligenteI18nEnUs = {
  header: {
    title: 'Sankhya Score intelligent opinion',
    badgeIa: 'AI',
    badgeBeta: 'Beta',
    subtitle: 'Analysis automatically generated from bureau and ERP data.',
    infoTooltip: 'This analysis is AI-generated and may contain errors. Review all information before making any credit decision. This opinion is only a recommendation.',
    collapseBtn: 'Collapse opinion',
    expandBtn: 'Expand opinion',
  },
  loading: {
    label: 'Generating intelligent opinion...',
  },
  unavailable: {
    title: 'Opinion temporarily unavailable.',
    text: 'The query data is complete and available below. Select Refresh query to try generating the opinion again.',
  },
  partial: {
    title: 'Partial analysis.',
    text: 'The query returned few indicators. The opinion below covers only the available data and may not reflect the full risk.',
  },
  risk: {
    label: 'Assessed risk',
    low: 'Low risk',
    medium: 'Medium risk',
    high: 'High risk',
  },
  confidence: {
    label: 'Analysis confidence',
    tooltip: 'High: complete bureau and ERP data. Medium: partial data. Low: few indicators available.',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
  },
  lists: {
    positives: 'Positive points',
    attention: 'Attention points',
    recommendation: 'AI recommendation',
  },
  decision: {
    approve: 'Approval recommended',
    approveWithCaution: 'Approval with caution',
    reject: 'Rejection recommended',
  },
  disclaimer: 'This analysis is generated by AI and may contain errors. Before making any credit decision, review all the information. This opinion is only a recommendation.',
};

export default ScoreParecerInteligenteI18nEnUs;
